var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSupplierFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14C17.1563 14 19.7143 11.5379 19.7143 8.5C19.7143 5.46211 17.1563 3 14 3C10.8438 3 8.28571 5.46211 8.28571 8.5C8.28571 11.5379 10.8438 14 14 14ZM18 15.375H17.2545C16.2634 15.8133 15.1607 16.0625 14 16.0625C12.8393 16.0625 11.7411 15.8133 10.7455 15.375H10C6.6875 15.375 4 17.9617 4 21.15V22.9375C4 24.0762 4.95982 25 6.14286 25H21.8571C23.0402 25 24 24.0762 24 22.9375V21.15C24 17.9617 21.3125 15.375 18 15.375Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSupplierFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/supplier-fill.070ca223.svg";
export { ForwardRef as ReactComponent };